/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum CredentialRedemptionType {
  IN_APP = 'IN_APP',
  WALLET_IOS = 'WALLET_IOS',
  WALLET_ANDROID = 'WALLET_ANDROID'
}
